
























import { Component, Vue, Mixins } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import { priUrlReg } from '@/apps/open/constants'
import Button from '@components/Button'
import { ElForm } from 'element-ui/types/form'
import { getDocPreviewCbConfig, setDocPreviewCbConfig } from '@/apps/open/services/app'

@Component({
  components: {
    ContentLayout,
    Button
  }
})
export default class Callback extends Vue {
  form = {
    callback_url: '',
    file_info: ''
  }

  loading: boolean = false

  $refs!: {
    form: ElForm
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get rules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '请输入正确的回调域名', trigger: ['blur', 'change'] } : { type: 'url', message: '请输入正确的回调域名', trigger: ['blur', 'change'] }
    return {
      callback_url: [
        { required: true, message: '请填写回调域名', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] },
        urlRule
      ],
      file_info: [
        { required: true, message: '请填写获取文件元数据接口配置', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ]
    }
  }

  isEdit: boolean = false

  get appId () {
    return this.$route.params.id
  }

  mounted () {
    this.getCallbackInfo()
  }

  saveCallbackConfig () {
    this.$refs.form.validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          callback_url: this.form.callback_url,
          file_info: this.form.file_info
        }
        const res = await setDocPreviewCbConfig(this.appId, params)
        if (res.data.result === 'ok') {
          this.$message.success('更新成功')
        }
      }
    })
  }

  async getCallbackInfo () {
    const res = await getDocPreviewCbConfig(this.appId)
    if (res.data.result === 'ok') {
      const info = res.data.object
      this.form = {
        callback_url: info.callback_url,
        file_info: info.file_info
      }
    }
  }
}
